import { render } from "./BookListView.vue?vue&type=template&id=5e983f0c&scoped=true"
import script from "./BookListView.vue?vue&type=script&lang=js"
export * from "./BookListView.vue?vue&type=script&lang=js"

import "./BookListView.vue?vue&type=style&index=0&id=5e983f0c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e983f0c"]])

export default __exports__